import React, { useMemo, useState } from 'react';
import { Container, Box, Typography, Grid, Card, CardMedia, CardContent, TextField, MenuItem, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Hero from '../components/Hero';
import posts from '../content_stub/sample_posts.js';
import { SEO } from '../utils/seo';
import meta from '../seo/keywords';
import HeroBlog from '../assets/images/hero-blog.jpg';

const categories = ['All','Maintenance','Efficiency','Safety','IAQ','Commercial','Heating','Cooling'];

export default function Blog() {
  const m = meta.blog;
  const [search, setSearch] = useState('');
  const [cat, setCat] = useState('All');
 

  const filtered = useMemo(() => {
    return posts.filter(p => {
      const matchesText = (p.title + ' ' + p.excerpt).toLowerCase().includes(search.toLowerCase());
      const matchesCat = cat === 'All' || p.category === cat;
      return matchesText && matchesCat;
    });
  }, [search, cat]);

  return (
    <Box>
      <SEO title={m.title} description={m.description} canonical={m.canonical} />
      <Hero title="HVAC Tips & Insights" subtitle="Local, seasonal guidance for Bloomington IN homes and businesses." bgImage={HeroBlog} />
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Box sx={{ display:'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
          <TextField label="Search" value={search} onChange={e=>setSearch(e.target.value)} />
          <TextField select label="Category" value={cat} onChange={e=>setCat(e.target.value)}>
            {categories.map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
          </TextField>
        </Box>
        <Grid container spacing={3}>
          {filtered.map(post => (
            <Grid item xs={12} md={4} key={post.slug}>
              <Card sx={{ height: '100%' }}>
                <CardMedia component="img" height="180" image={post.featuredImage} alt={post.title} />
                <CardContent>
                  <Typography variant="overline" color="text.secondary">{post.category}</Typography>
                  <Typography variant="h6" component={RouterLink} to={'/blog/' + post.slug} style={{ textDecoration: 'none' }}>{post.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{post.excerpt}</Typography>
                  <Button component={RouterLink} to={'/blog/' + post.slug} sx={{ mt: 1 }}>Read More</Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
